import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GridDataResult, PageChangeEvent, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { orderBy, process, State, SortDescriptor } from '@progress/kendo-data-query';
import { PanelBarExpandMode } from '@progress/kendo-angular-layout';
import { formatDate } from '@angular/common';
import { forEach } from 'lodash';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { IChangeCustomer, ICustomer, ICustomerSuggestion, ISampleRegion, IUser, User } from '../../../../core/models';
import { AppNotifyService } from '../../../../core/services/app-notify.service';
import { CustomerService } from '../../../../core/services/customer.service';
import { UserService } from '../../../../core/services/user.service';
import { HelperService } from '../../../../core/services/helper.service';
import { NotifyType } from 'src/app/core/enums/NotifyType';
import { ProductSampleFulfillmentService } from '../../../../core/services/product-sample-fulfillment.service';
@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrls: ['./user-admin.component.scss']
})
export class UserAdminComponent implements OnInit {

  //#region member variable declaration
  @ViewChild('panelbar', { static: false }) panel;
  public expandMode: number = PanelBarExpandMode.Multiple;
  public kendoPanelBarExpandMode: any = PanelBarExpandMode;

  showUserForm: boolean;
  showUserAdminGrid: boolean = true;
  showWorkListGrid: boolean = true;

  getDefaultCustomer: IChangeCustomer[];
  getMSCCustomer: IChangeCustomer[];
  allRolesGridView: GridDataResult;
  allRolesGridData: [];
  selectedRolesGridView: GridDataResult;
  selectedRolesGridData: [];
  getAllLanguages: any;
  userAdminGridLoading: boolean;
  userAdminGridView: GridDataResult;
  worklistGridView: GridDataResult;
  custDataResult: GridDataResult;
  users: Array<IUser> = [];
  workListGridData: Array<IUser> = [];
  MSCData: Array<any> = [];
  roles: Array<any> = [];
  newUser: IUser;
  public isCSCAccount = false;
  public isMSCAccount = false;
  public ShowMSCGrid = true;
  public AllRoles: any[];
  selectedCustomer: string;
  worklistGridLoading: boolean;
  showWorkListUserForm: boolean;
  isWorkListDetails: boolean;
  pendingApprovalRequestCount: number = 0;
  workListTitle: string = 'Worklist';
  public gridItemToRemove: any;
  public removeConfirmationSubject: Subject<boolean> = new Subject<boolean>();
  getUserRegion: ISampleRegion[] = [];
  isDefaultUserRegion: boolean = false;
  //#endregion
  //#region Constructor ng events
  constructor(private userService: UserService, private customerService: CustomerService,
    private appNotifyService: AppNotifyService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder, private helperService: HelperService,
    private productSampleFulfillmentService: ProductSampleFulfillmentService) {
  }

  ngOnInit(): void {
    this.userAdminGridLoading = true;
    this.loadAllUserList();
    this.getAllRoles();
    this.getAllCustomers();
    this.getDefaultCustomer = [];
    this.getMSCCustomer = [];
    this.bindlanguageData();
    this.isWorkListDetails = false;
    this.getAllRegions();
  }
  bindlanguageData() {
    this.getAllLanguages = [{ userLanguage: 'eng' }, { userLanguage: 'fre' }];
  }

  //#endregion
  //#region labels and variable declarations 
  newUserForm = {
    label: {
      opened: false,
      isSubmitted: false,
      userFirstName: "First Name",
      userLastName: "Last Name",
      userName: "User Name",
      phoneNumber: "Phone Number",
      password: "Password",
      faxNumber: "Fax Number",
      email: "Email",
      customerName: "Customer Name",
      customerNumber: "Customer Number",
      adminNote: "Admin Note",
      dateAdded: "Request Date",
      isActive: "Active",
      isMSCAccount: "Multi Customer Account",
      isCSCAccount: "CSC Account",
      roles: "Roles",
      hasInvoiceInquiry: "Has Invoice Inquiry",
      hasAccountSummary: "Has Account Summary",
      hasManageAddress: "Has Manage Address",
      canPlaceOrder: "Can Place Order",
      forcePasswordReset: "Force Password Reset",
      forceTermsAndCondition: "Force Terms And Condition",
      lastTermsAndConditionAccepted: "Last Terms And Condition Accepted",
      lockCount: "Lock Count",
      effectiveFrom: "Effective From",
      effectiveTo: "Effective To",
      userLanguage: "Select default language",
      sendTempPW: "Send Temp Password",
      userRegion: "Region",
      isInvalidUserId: false,
      isEmptyUserName: false,
      isEmptyFirstName: false,
      isEmptyLastName: false,
      isEmptyDefaultCustomer: false,
      isEmptyMSCCustomer: false,
      isEmptyPassword: false,
      isEmptyBillingStreet1: false,
      isEmptyBillingCity: false,
      isEmptyBillingState: false,
      isEmptyBillingCountry: false,
      isEmptyBillingZipCode: false,
      isEmptyBillingPhoneNumber: false,
      isUserNameExist: false,
      showUserNameIcon: false,
      userNameProcessing: false,
      isUserNameValid: false,
      isInvalidPhoneNumber: false,
      isInvalidPhoneNumberMessage: false,
      isInvalidEmail: false,
      todayDate: new Date(),
      isDetailsSubmitted: false,
      isRolesSubmitted: false,
      isBasicDetailValid: false,
      isUserRolesValid: false,
      isAccountActivityValid: false,
      isEmailFormatInValid: false,
      isInvalidStreet1Address: false,
      isInvalidStreet2Address: false,
      isInvalidCity: false,
      isInvalidState: false,
      isInvalidCounty: false,
      isInvalidCountry: false,
      isInvalidZipCode: false,
      isInvalidBillingPhoneNumber: false,
      isEmptyRegion: false
    },
    saveInProcess: false,
  }
  userAdmin = {
    label: {
      userFirstName: "First Name",
      userLastName: "Last Name",
      userName: "UserName",
      customerName: "CustomerName",
      customerNumber: "CustomerNumber",
      dateAdded: "Request Date",
      isActive: "IsActive",
      isMSCAccount: "IsMSC",
      isCSCAccount: "IsCSC",
      roles: "Roles",
      deleteConfirmLbl: 'Are you sure you want to delete user ',
      deleteYesLbl: 'Yes',
      deleteNoLbl: 'No',
      confirmLbl: 'Please confirm',
    }
  }
  setWorkListTitle() {
    if (this.pendingApprovalRequestCount > 0) {
      this.workListTitle = this.workListTitle + '(' + this.pendingApprovalRequestCount.toString() + ")";
    }
    else {
      this.workListTitle = 'WorkList';
    }
  }
  //#endregion
  //#region tab select Api call
  onTabSelected(event) {
    
    if (event.index == 0) {
      this.showUserAdminGrid = true;
      this.showUserForm = false;
      this.newUser = <User>{};
      this.savedUserName = "";
    }
    if (event.index == 1) {
      if (this.isWorkListDetails == false) {
        this.loadWorkListGridData();
      }
      this.showWorkListGrid = true;
      this.showWorkListUserForm = false;
      this.newUser = <User>{};
    }
  }
  //#endregion

  //#region User Administration Tab pane operations
  loadAllUserList() {
    this.userService.getAll().subscribe(response => {
      if (response && !response.isError) {
        const data = response.data;
        this.users = data.filter(x => x.isApproved);
        this.workListGridData = data.filter(x => !x.isApproved);
        
        this.workListGridData.every(this.formateDates);
        this.pendingApprovalRequestCount = this.workListGridData.length;
        this.setWorkListTitle();
        this.bindWorkListGrid();
        this.isWorkListDetails = true;
        this.bindUserAdminGrid();
        this.userAdminGridLoading = false;
        this.worklistGridLoading = false;
      }
      else {
        //implement error handlers
      }
    });
  }

  //#region pagination, sorting, filtering for User Administration grid

  public userAdminGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'userId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindUserAdminGrid(): void {
    const data = this.users;
    this.userAdminGridView = process(data, this.userAdminGridstate);
  }

  public userAdminGridSortChange(sort: SortDescriptor[]): void {
    this.userAdminGridstate.sort = sort;
    this.bindUserAdminGrid();
  }
  public userAdminPageChange({ skip, take }: PageChangeEvent): void {
    this.userAdminGridstate.skip = skip;
    this.userAdminGridstate.take = take;
    this.bindUserAdminGrid();
  }

  public userAdminDataStateChange(state: DataStateChangeEvent): void {
    this.userAdminGridstate = state;
    this.bindUserAdminGrid();
  }

  //#endregion
  //#endregion
  //#region Worklist Tab pane operations
  loadWorkListGridData() {
    this.worklistGridLoading = true;
    this.userService.getWorkListUsers().subscribe(response => {
      this.worklistGridLoading = false;
      this.workListGridData = response;
      this.bindWorkListGrid();
      this.isWorkListDetails = true;
    });
  }
  //#region pagination, sorting, filtering for Worklist grid

  public worklistGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'userId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindWorkListGrid(): void {
    const data = this.workListGridData;
    this.worklistGridView = process(data, this.worklistGridstate);
  }

  public worklistGridSortChange(sort: SortDescriptor[]): void {
    this.worklistGridstate.sort = sort;
    this.bindWorkListGrid();
  }
  public worklistGridPageChange({ skip, take }: PageChangeEvent): void {
    this.worklistGridstate.skip = skip;
    this.worklistGridstate.take = take;
    this.bindWorkListGrid();
  }

  public worklistGridDataStateChange(state: DataStateChangeEvent): void {
    this.worklistGridstate = state;
    this.bindWorkListGrid();
  }

  //#endregion
  //#endregion
  //#region User Dialog save/update operations
  selectedLanguage: string;
  selectLanguage(data) {
    this.selectedLanguage = data.userLanguage;
  }
  checkUserNameExist() {
    this.newUserForm.label.showUserNameIcon = false;
    this.newUserForm.label.userNameProcessing = false;
    this.newUserForm.label.isUserNameValid = false;
    if (this.newUser.userName) {
      if (this.savedUserName == this.newUser.userName) {
        this.newUserForm.label.isUserNameValid = true;
        return;
      }
      this.newUserForm.label.isEmptyUserName = false;
      this.newUserForm.label.userNameProcessing = true;
      //const body = {
      //  userName: this.newUser.userName
      //}
      this.userService.isUserNameAvailable(this.newUser.userName).subscribe((response: any) => {
        this.newUserForm.label.userNameProcessing = false;
        if (response.data) {
          this.newUserForm.label.showUserNameIcon = false;
          this.newUserForm.label.isUserNameValid = true;
        }
        else {
          this.newUserForm.label.showUserNameIcon = true;
          this.newUserForm.label.isUserNameValid = false;

        }
      })
    }
  }
  //#region ADD USER
  openUserForm(): void {
    this.showUserForm = true;
    this.showUserAdminGrid = false;
    this.showWorkListGrid = false;
    this.resetUserForm();
  }
  closeUserForm(): void {
    this.showUserForm = false;
    this.showUserAdminGrid = true;
    this.showWorkListGrid = true;
    this.resetUserForm();
  }

  resetUserForm() {
    this.newUser = new User();
    this.savedUserName = "";
    this.MSCData = [];
    this.bindCustomerGrid();
    this.roles = [];
    this.bindSelectedRolesGrid();
    this.newUserForm.label.showUserNameIcon = false;
    this.newUserForm.label.userNameProcessing = false;
    this.newUserForm.label.isUserNameValid = false;
    this.newUserForm.label.isEmptyUserName = false;
    this.newUserForm.label.isEmptyFirstName = false;
    this.newUserForm.label.isEmptyLastName = false;
    this.newUserForm.label.isEmptyDefaultCustomer = false;
    this.newUserForm.label.isEmptyMSCCustomer = false;
    this.newUserForm.label.isEmptyPassword = false;
    this.newUserForm.label.isSubmitted = false;
    this.newUserForm.label.isDetailsSubmitted = false;
    this.newUserForm.label.isBasicDetailValid = false;
    this.newUserForm.label.isUserRolesValid = false;
    this.newUserForm.label.isRolesSubmitted = false;
    this.newUserForm.label.isAccountActivityValid = false;
    this.newUserForm.label.isEmailFormatInValid = false;
    this.ShowMSCGrid = true;
    this.selectedCustomerName = "";
    this.selectedCustomerNumber = "";
    this.newUserForm.label.isEmptyRegion = false;
    this.selectedPaymentTerms = "";
    this.isCCRoleCustomer = false;
    this.isCCRoleCustomerText = '';
  }

  onMSCChange(): void {
    if (this.ShowMSCGrid)
      this.ShowMSCGrid = false;
    else {
      this.ShowMSCGrid = true;
      this.newUser.mscCustomer = [];
      this.MSCData = [];//Clear the grid on msc uncheck
      this.bindCustomerGrid();
    }
  }
  onCSCChange() {

  }

  //#endregion
  closeWorkListUserForm(): void {
    this.showWorkListUserForm = false;
    this.showUserAdminGrid = true;
    this.showWorkListGrid = true;
    this.loadWorkListGridData();
    this.resetUserForm();
  }



  //#region customer dropdown and grid operations
  addCustomer() {
    if (this.mscSelectedCustomer) {
      const custNumber = this.mscSelectedCustomer.customerNumber.toString();
      //checks if customer is already assigned
      var isCustomerExist = false;
      if (this.MSCData.length > 0) {
        const t = this.MSCData.find(r => r.customerNumber === custNumber);
        if (t) {
          isCustomerExist = true;
        } else {
          isCustomerExist = false;
        }
      }
      if (isCustomerExist == false) {
        const customer = { customerName: this.mscSelectedCustomer.customerName, customerNumber: custNumber, Default: false, UserId: 'abc', paymentTerms: this.mscSelectedCustomer.paymentTerms };
        this.MSCData.push(customer);
        this.bindCustomerGrid();
      }
    }
    this.mscSelectedCustomer = "";
    this.newUser.mscCustomer = [];
  }
  selectedCustomerNumber: "";
  selectedCustomerName: "";
  //addDefaultCustomer() {
  //  
  //  if (this.selectedCust) {
  //    this.selectedCustomerNumber = this.selectedCust.customerNumber.toString();
  //    this.selectedCustomerName = this.selectedCust.customerName
  //  }
  //  this.selectedCust = "";
  //  this.newUser.defaultCustomer = [];

  //}

  customerSelect(event) {
    this.selectedCustomerNumber = event.customerNumber.toString();
    this.selectedCustomerName = event.customerName;
    this.getDefaultCustomer = this.customerDropdownData;
    this.newUserForm.label.isEmptyDefaultCustomer = false;
    if (this.selectedCustomerNumber.toString() == '100195' || this.selectedCustomerNumber.toString() == '100238')      
    {
      this.isDefaultUserRegion = true;
    }   
    else {
      this.isDefaultUserRegion = false;
      this.newUser.userRegion = null;
    }    
    this.selectedPaymentTerms = event.paymentTerms;
  }
  onCloseDefaultCustomerFilter(event) {
    this.getDefaultCustomer = this.customerDropdownData;
  }
  mscSelectedCustomer: any;
  mscCustomerSelect(event) {
    this.mscSelectedCustomer = event;
    this.getMSCCustomer = this.customerDropdownData;
    this.newUserForm.label.isEmptyMSCCustomer = false;
  }
  onCloseMSCCustomerFilter(event) {
    this.getMSCCustomer = this.customerDropdownData;
  }
  handleDefaultCustomerFilter(searchQuery) {
    /*this.getDefaultCustomer = this.customerDropdownData.filter((s) => s.customerName.toLowerCase().indexOf(value.toLowerCase()) !== -1);*/
    const searchString = searchQuery;
    if (searchQuery.length > 0) {
      searchQuery = searchQuery.toUpperCase();
      this.customerService.getSuggestion(searchString)
        .subscribe((data: ICustomerSuggestion[]) => {
          //this.customerDropdownData = data;
          //this.getDefaultCustomer = this.customerDropdownData.filter((s) => s.customerName.toLowerCase().indexOf(searchQuery.toLowerCase()) !== -1);
          this.getDefaultCustomer = data;
        });
    } else {
    }
  }
  handleMSCCustomerFilter(searchQuery) {
    /* this.getMSCCustomer = this.customerDropdownData.filter((s) => s.customerName.toLowerCase().indexOf(value.toLowerCase()) !== -1);*/
    const searchString = searchQuery;
    if (searchQuery.length > 0) {
      searchQuery = searchQuery.toUpperCase();
      this.customerService.getSuggestion(searchString)
        .subscribe((data: ICustomerSuggestion[]) => {
          this.getMSCCustomer = data;
        });
    } else {
    }
  }

  customerDropdownData: any;
  public getAllCustomers() {
    this.userService.getAllCustomers().subscribe(response => {
      this.customerDropdownData = response;//response.slice(0, 20).map(r => ({ customerName: r.customerName, customerNumber: r.customerNumber,customerNameToDisplay:r.customerNameToDisplay }));
      this.getDefaultCustomer = this.customerDropdownData;//binding only top 20 record in customer dropdown
      this.getMSCCustomer = this.customerDropdownData;//binding only top 20 record in customer dropdown
    });
  }

  public deleteSelectedCustomers(customerNumber) {
    var rowIndex = this.MSCData.findIndex(d => d.customerNumber == customerNumber);
    this.MSCData.splice(rowIndex, 1);
    this.bindCustomerGrid();
  }
  //#region pagination, sorting,filtering for all roles grid

  public mscCustomerGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'customerNumber',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindCustomerGrid(): void {
    this.custDataResult = process(this.MSCData, this.mscCustomerGridstate);
  }

  public mscCustomerGridSortChange(sort: SortDescriptor[]): void {
    this.mscCustomerGridstate.sort = sort;
    this.bindCustomerGrid();
  }
  public mscCustomerGridPageChange({ skip, take }: PageChangeEvent): void {
    this.mscCustomerGridstate.skip = skip;
    this.mscCustomerGridstate.take = take;
    this.bindCustomerGrid();
  }

  public mscCustomerDataStateChange(state: DataStateChangeEvent): void {
    this.mscCustomerGridstate = state;
    this.bindCustomerGrid();
  }
  //#endregion
  //#region AllRegions
  getAllRegions() {
    this.productSampleFulfillmentService.GetSampleRegions().subscribe(response => {
      this.getUserRegion = response;
    });
  }
  //#endregion
  //#region Roles panel operations
  public getAllRoles() {
    this.userService.getAllRoles().subscribe(response => {
      this.allRolesGridData = response as [];
      this.bindAllRolesGrid();
    });
  }
  addRoles(dataItem) {
    if (dataItem) {
      var isRolesExist = false;
      //checks if role is already assigned
      if (this.roles.length > 0) {
        const t = this.roles.find(r => r.rolesCode === dataItem.rolesCode);
        if (t) {
          isRolesExist = true;
        } else {
          isRolesExist = false;
        }
      }
      if (isRolesExist == false) {
        const gridObj = { rolesCode: dataItem.rolesCode };
        this.roles.push(gridObj);
        this.bindSelectedRolesGrid();
      }

    }
  }

  public deleteSelectedRoles(rowIndex) {
    this.roles.splice(rowIndex, 1);
    this.bindSelectedRolesGrid();
  }

  //#region pagination, sorting,filtering for all roles grid

  public allRolesGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'roleId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindAllRolesGrid(): void {
    this.allRolesGridView = process(this.allRolesGridData, this.allRolesGridstate);
  }

  public allRolesGridSortChange(sort: SortDescriptor[]): void {
    this.allRolesGridstate.sort = sort;
    this.bindAllRolesGrid();
  }
  public allRolesGridPageChange({ skip, take }: PageChangeEvent): void {
    this.allRolesGridstate.skip = skip;
    this.allRolesGridstate.take = take;
    this.bindAllRolesGrid();
  }

  public allRolesDataStateChange(state: DataStateChangeEvent): void {
    this.allRolesGridstate = state;
    this.bindAllRolesGrid();
  }
  //#endregion
  //#region pagination, sorting,filtering for selected roles grid

  public selectedRolesGridstate: State = {
    skip: 0,
    take: 10,
    group: null,
    sort: [{
      field: 'roleId',
      dir: 'desc'
    }],
    filter: {
      logic: 'and',
      filters: []
    },
  };
  public bindSelectedRolesGrid(): void {
    this.selectedRolesGridView = process(this.roles, this.selectedRolesGridstate);
  }

  public selectedRolesGridSortChange(sort: SortDescriptor[]): void {
    this.selectedRolesGridstate.sort = sort;
    this.bindSelectedRolesGrid();
  }
  public selectedRolesGridPageChange({ skip, take }: PageChangeEvent): void {
    this.selectedRolesGridstate.skip = skip;
    this.selectedRolesGridstate.take = take;
    this.bindSelectedRolesGrid();
  }

  public selectedRolesDataStateChange(state: DataStateChangeEvent): void {
    this.selectedRolesGridstate = state;
    this.bindSelectedRolesGrid();
  }
  //#endregion
  //#endregion

  public insertUserData(savingType, activeTab) {
    
    //if all the validation successfully checked close the panel
    this.newUserForm.label.isDetailsSubmitted = true;
    this.newUserForm.label.isRolesSubmitted = true;

    this.newUserForm.label.isSubmitted = true;
    this.newUserForm.label.isBasicDetailValid = this.validateNewUserDetailsForm();
    if (this.roles.length > 0) {
      this.newUser.roles = this.roles.map(r => r.rolesCode);
      this.newUserForm.label.isUserRolesValid = true;
    }
    //#region for Validating CC Role
    if (this.roles.length > 0) {
      this.validateCCCustomerRole();
    }
    //#endregion
    this.newUserForm.label.isAccountActivityValid = true;
    if (this.newUserForm.label.isBasicDetailValid && this.newUserForm.label.isUserRolesValid) {    //add condition for user roles and account activity panel
      this.activatePanel(-1);
      if (this.newUser.phoneNumber) {
        const p = this.newUser.phoneNumber.toString();
        this.newUser.phoneNumber = p;
      }
      if (this.newUser.billingPhoneNumber) {
        const p = this.newUser.billingPhoneNumber.toString();
        this.newUser.billingPhoneNumber = p;
      }
      if (activeTab == 'workList') {
        this.newUser.userLanguage = this.selectedLanguage;
      }
      if (this.newUser.isMSCAccount) {
        this.newUser.mscData = this.MSCData.map(r => r.customerNumber.toString());
      }
      this.newUser.customerName = this.selectedCustomerName;
      this.newUser.customerNumber = this.selectedCustomerNumber;
      if (savingType == "approve") {
        this.newUser.isApproved = true;
      } else {
        this.newUser.isApproved = false;
      }
      this.newUser.addedBy = this.userService.readUserObject.userId;
      //console.log(this.newUser);
      //return;
      this.userService.addUser(this.newUser).subscribe(() => {
        this.savedUserName = "";
        if (activeTab == 'workList') {
          this.closeWorkListUserForm();
          //load worklist grid here
        } else {
          this.closeUserForm();
          this.loadAllUserList();

        }
      }, error => {
          this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
      })
    }
  }
  emailLeave() {
    if (this.newUser.email) {
      const res = this.helperService.isEmailFormatValid(this.newUser.email);
      if (!res) {
        this.newUserForm.label.isEmailFormatInValid = true;
      } else {
        this.newUserForm.label.isEmailFormatInValid = false;
      }
    }
  }
  
  public validateNewUserDetailsForm(): boolean {
    let isValid = true;
    if (this.newUserForm.label.isDetailsSubmitted) {
      if (this.newUser.userName) {
        this.newUserForm.label.isEmptyUserName = false;
      } else {
        this.newUserForm.label.isEmptyUserName = true;
        isValid = false;
      }
      if (this.newUser.userFirstName) {
        this.newUserForm.label.isEmptyFirstName = false;
      } else {
        this.newUserForm.label.isEmptyFirstName = true;
        isValid = false;
      }
      if (this.newUser.userLastName) {
        this.newUserForm.label.isEmptyLastName = false;
      } else {
        this.newUserForm.label.isEmptyLastName = true;
        isValid = false;
      }
      if (this.isDefaultUserRegion) {
        if (this.newUser.userRegion) {
          this.newUserForm.label.isEmptyRegion = false;
        } else {
          this.newUserForm.label.isEmptyRegion = true;
          isValid = false;
        }
      }      
      if (this.selectedCustomerNumber) {
        this.newUserForm.label.isEmptyDefaultCustomer = false;
      } else {
        this.newUserForm.label.isEmptyDefaultCustomer = true;
        isValid = false;
      }
      if (this.newUser.isMSCAccount) {
        if (this.MSCData.length > 0) {
          this.newUserForm.label.isEmptyMSCCustomer = false;
        } else {
          this.newUserForm.label.isEmptyMSCCustomer = true;
          isValid = false;
        }
      }

      if (this.newUser.email) {
        const res = this.helperService.isEmailFormatValid(this.newUser.email);
        if (!res) {
          this.newUserForm.label.isEmailFormatInValid = true;
          isValid = false;
        }
      } else {
        this.newUserForm.label.isEmailFormatInValid = true;
        isValid = false;
      }
    }
    return isValid;

  }

  //#endregion
  //#endregion
  savedUserName: string;
  onEditUser(user: IUser, gridName): void {

    this.resetUserForm();
    this.userService.loadUserDetailsForEdit(user.userId).subscribe(response => {
      
      //if (!response.isError && response.data) {

      if (response.user.isMSC == true) {
        this.MSCData = [];
        this.MSCData = response.mscData;
        this.bindCustomerGrid();
        this.ShowMSCGrid = false;
      }
      if (response.roles.length > 0) {
        this.roles = response.roles;
        this.bindSelectedRolesGrid();
      }
      this.newUser = response.user;
      this.newUser.forceTermsAndCondition = response.user.forceTermsAndConditions;
      this.newUser.email = response.user.userEmail;
      if (response.user.userPhoneNumber)
        this.newUser.phoneNumber = Number.parseInt(response.user.userPhoneNumber) as any;
      if (response.user.billingPhoneNumber)
        this.newUser.billingPhoneNumber = Number.parseInt(response.user.billingPhoneNumber) as any;
      this.newUser.isMSCAccount = response.user.isMSC;
      this.newUser.isCSCAccount = response.user.isCSC;
      this.newUser.userEnteredCustomerName = response.user.userEnteredCustomerName;
      this.newUser.userEnteredCustomerNumber = response.user.userEnteredCustomerNumber;
      this.newUser.lastLogin = (this.newUser.lastLogin != null && this.newUser.lastLogin != "")? formatDate(this.newUser.lastLogin, 'MM/dd/yyyy hh:mm a', 'en') : this.newUser.lastLogin;
      this.selectedCustomerName = '';
      this.selectedCustomerNumber = '';
      //if (gridName != 'worklist') {
        //this.selectedCustomerName = response.user.customerName;
        //this.selectedCustomerNumber = response.user.customerNumber;
      //}
      this.savedUserName = response.user.userName;
      this.selectedPaymentTerms = '';
      this.selectedCustomerName = response.user.customerName;
      this.selectedCustomerNumber = response.user.customerNumber;
      this.selectedCustomerNumber = response.user.customerNumber;
      this.selectedPaymentTerms = this.getPaymentTermsByCustomerNum(response.user.customerNumber);
      //Need to bind language dropdown 
      this.showUserAdminGrid = false;
      this.showWorkListGrid = false;
      if (gridName == "worklist") {
        this.showWorkListUserForm = true;
      } else {
        this.showWorkListUserForm = false;
        this.showUserForm = true;
      }
      //}
      //else {
      //  //error handler
      //}
      if (response.user.customerNumber == '100195' || response.user.customerNumber == '100238') {
        this.isDefaultUserRegion = true;
      } else {
        this.isDefaultUserRegion = false;
      }
    });
  }
  gridIsActiveSwitchChange(editUser: IUser): void {
    console.log(editUser.isActive);
  }

  //#region panel change
  continueNextPanel(activeTab) {
    this.newUserForm.label.isDetailsSubmitted = true;
    if (activeTab == 'basic details') {
      if (!this.validateNewUserDetailsForm()) {
        this.newUserForm.label.isBasicDetailValid = false;
        return;
      } else {
        this.newUserForm.label.isBasicDetailValid = true;
      }
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[1].expanded = true;
      this.panel.childrenItems[1].selected = true;
    }
    else if (activeTab == 'roles') {
      this.newUserForm.label.isRolesSubmitted = true;
      if (this.roles.length > 0) {
        this.validateCCCustomerRole();
        this.newUserForm.label.isUserRolesValid = true;
      } else {
        this.newUserForm.label.isUserRolesValid = false;
        return;
      }
      this.panel.childrenItems.forEach(item => {
        if (item.expanded) {
          item.expanded = false;
          item.selected = false;
        }
      });
      this.panel.childrenItems[2].expanded = true;
      this.panel.childrenItems[2].selected = true;
    }
  }
  public activatePanel(index: number) {
    this.panel.childrenItems.forEach(item => {
      if (item.expanded) {
        item.expanded = false;
        item.selected = false;
      }
    });
    if (index !== -1) {
      this.panel.childrenItems[index].expanded = true;
      this.panel.childrenItems[index].selected = true;
    }
  }
  //#endregion
  //#region delete item
  public removeType: string;
  public removeConfirmation(dataItem, type): Subject<boolean> {
    this.gridItemToRemove = dataItem; // show delete item confirmation box
    this.removeType = type;
    return this.removeConfirmationSubject;
  }

  public formateDates(dataItem)
  {
    var datedata = dataItem.dateAdded;
    dataItem.dateAdded = formatDate(datedata, 'MM/dd/yyyy', 'en');
    return dataItem;
  }
  public confirmRemove(shouldRemove: boolean): void {
    if (shouldRemove) {
      this.removeConfirmationSubject.next(shouldRemove);
      this.userRemoveHandler();
    }
    else {
      this.removeConfirmationSubject.next(shouldRemove);
      this.gridItemToRemove = null;
      this.removeType = "";
    }
  }
  public userRemoveHandler() {
    this.userService.deleteUser(this.gridItemToRemove).subscribe((isRemoved: boolean) => {
      const userId = this.gridItemToRemove.userId;
      this.gridItemToRemove = null;
      this.appNotifyService.notify(NotifyType.SUCCESS, "Selected user has been removed.");

      if (this.removeType == "Admin") {
        if (this.users) {
          //This is a Local Remove
          const index = (this.users).findIndex(r => r.userId === userId);
          (this.users).splice(index, 1);
          this.bindUserAdminGrid();

        }
      }
      else if (this.removeType == "Worklist") {
        if (this.workListGridData) {
          //This is a Local Remove
          const index = (this.workListGridData).findIndex(r => r.userId === userId);
          (this.workListGridData).splice(index, 1);
          this.pendingApprovalRequestCount = this.workListGridData.length;
          this.workListTitle = 'WorkList';
          this.setWorkListTitle();
          this.bindWorkListGrid();

        }
      }
      this.removeType = "";

    }, error => {
      this.appNotifyService.notify(NotifyType.ERROR, 'An Error Occured');
    });
  }

  //#endregion

  //#region CC role related changes
  selectedPaymentTerms: string = "";
  public isCCRoleCustomer = false;
  public isCCRoleCustomerText: string = "";
  public ccCustomerPaymentTerms: string = "CIA";
  getPaymentTermsByCustomerNum(customerNum: number) {
    var customerObj = this.customerDropdownData.filter(x => x.customerNumber == customerNum);
    if (customerObj && customerObj.length>0)
      return customerObj[0].paymentTerms;
    return "";
  }
  validateCCCustomerRole() {
    let ccCustomer = false;
    if (this.newUser.isMSCAccount) {
      var obj = this.MSCData.filter(r => r.paymentTerms.toString() == this.ccCustomerPaymentTerms.toString());
      if (obj.length > 0)
        ccCustomer = true;
    }
    if (this.selectedPaymentTerms.toString() == this.ccCustomerPaymentTerms.toString())
      ccCustomer = true;
    if (this.roles.length > 0 && ccCustomer) {
      this.isCCRoleCustomer = false;
      //var ccRole = this.roles.filter(x => x.rolesCode == 'EXTcheckoutCConly' || x.rolesCode == 'EXTcheckoutCC');
      var ccRole = this.roles.filter(x => x.rolesCode == 'EXTcheckoutCC'); //  remove the EXTcheckoutCConly as mentio in K50-1510 
      if (ccRole.length > 0) {
        this.newUserForm.label.isUserRolesValid = true;
        this.isCCRoleCustomerText = '';
      }
      else {
        this.newUserForm.label.isUserRolesValid = false;
        this.isCCRoleCustomer = true;
        this.isCCRoleCustomerText = 'Selected Roles WARNING! Customer Terms CIA Requires Role "EXTcheckoutCC"'
      }
    }
    else {
      this.newUserForm.label.isUserRolesValid = true;
      this.isCCRoleCustomerText = '';
    }

  }
  //#endregion
}
 
